import React from 'react';
import {Link} from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import {Accordion, Form} from "react-bootstrap";

const EditRolePage = () => {
    return (
        <>
            <PageHeader name="Edit Role" />

            <div className="main-container container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card custom-card">
                            <div className="card-header w-100">
                                <div className="row w-100 m-0 justify-content-between">
                                    <div className="col-auto p-0 d-flex gap-1">
                                        <Link
                                            to="/roles"
                                            className="btn btn-dark"
                                        >
                                            Close
                                        </Link>
                                    </div>
                                    <div className="col-auto p-0 d-flex gap-1">
                                        <Link
                                            to="/roles"
                                            className="btn btn-primary"
                                        >
                                            Save
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <Form>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Role Name:</Form.Label>
                                        <Form.Control type="text" placeholder="Enter Role Name" />
                                    </Form.Group>
                                </Form>

                                <Form.Label>Select Permission:</Form.Label>
                                <Accordion defaultActiveKey="0">
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Employees</Accordion.Header>
                                        <Accordion.Body>
                                            {['View all employees', 'View employee', 'Add employee', 'Edit employee'].map((type) => (
                                                <div key={`default-${type}`} className="mb-3">
                                                    <Form.Check // prettier-ignore
                                                        type="checkbox"
                                                        id={`default-${type}`}
                                                        label={`default ${type}`}
                                                    />
                                                </div>
                                            ))}
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header>Lead Source</Accordion.Header>
                                        <Accordion.Body>
                                            {['View all Lead Source', 'View Lead Source', 'Add Lead Source', 'Edit Lead Source'].map((type) => (
                                                <div key={`default-${type}`} className="mb-3">
                                                    <Form.Check // prettier-ignore
                                                        type="checkbox"
                                                        id={`default-${type}`}
                                                        label={`default ${type}`}
                                                    />
                                                </div>
                                            ))}
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditRolePage;